import React, { Component } from "react";
export default class BookInformation extends Component {
  render() {
    return (
      <div
        className="book-info-container"
        key={this.props.data.id}
        onClick={this.props.handleClick}
      >
        <div className="img-container">
          <img
            src={require(`../data/images/${this.props.data.imageUrl}`).default}
            className="book-img"
            alt={this.props.data.title}
          />
        </div>
        <div className="book-info">
          <h3 className="book-title">{this.props.data.title}</h3>
          <div className="book-author">{this.props.data.author}</div>
        </div>
      </div>
    );
  }
}
